import { render, staticRenderFns } from "./UITableActions.vue?vue&type=template&id=47e88b86&scoped=true"
import script from "./UITableActions.vue?vue&type=script&lang=js"
export * from "./UITableActions.vue?vue&type=script&lang=js"
import style0 from "./UITableActions.vue?vue&type=style&index=0&id=47e88b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e88b86",
  null
  
)

export default component.exports